import type { BaseEvent } from './dispatcher';

export interface PreviewModalOpenEvent extends BaseEvent<'previewModalOpen'> {
  payload: {
    orderId: number;
  };
}

export function createPreviewModalOpenEvent(orderId: number): PreviewModalOpenEvent {
  return {
    type: 'previewModalOpen',
    payload: { orderId },
  };
}
